import styled from "styled-components";

export const AppContainer = styled.div`
  & * {
    font-family: 'Futura PT';
    font-size: 18px;
    text-transform: initial;
    letter-spacing: normal;
    box-sizing: border-box;

    @media (max-width: 768px) {
      font-size: 16px;
    }
  }
`
